////////////////////////////////////////////////////////////
//     							                                      //
//  Program: ListingAvailabilityRule.jsx                  //
//  Application: Lisiting Availability Rule               //
//  Option: Lisiting Availability Rule                    //
//  Developer: Ashish Kumar						                    //
//  Date: 2025-06-24                                      //
//                                                        //
////////////////////////////////////////////////////////////

import React, { Component } from "react";
import SimpleReactValidator from "simple-react-validator";
import Alerts from "../common/Alerts";
import ListingService from "../../services/ListingService";
import ListingAvailabilityRuleService from "../../services/ListingAvailabilityRuleService";
import { Modal, Table, InputGroup, Form } from "react-bootstrap";
import Moment from "moment";
import deleteicon from "../../assets/images/delete.svg";
import DatePicker from "react-datepicker";
// import Select from "react-select";

export class ListingAvailabilityRule extends Component {
  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator({ autoForceUpdate: this });
    this.fromDateInputGroupRef = React.createRef();
    this.toDateInputGroupRef = React.createRef();
    this.editFromDateInputGroupRef = React.createRef();
    this.editToDateInputGroupRef = React.createRef();
    this.state = {
      fromDatePlacement: "bottom-start",
      toDatePlacement: "bottom-start",
      editFromDatePlacement: "bottom-start",
      editToDatePlacement: "bottom-start",
      listingId: props.listingId || 1, // Replace with dynamic listingId
      days: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ],
      selectedRestrictionType: [],
      restrictionTypeList: [
        { label: "Stay through", value: "1" },
        { label: "Arrival based", value: "2" },
      ],
      checkinDays: {},
      checkoutDays: {},
      loading: true,
      // Add default values for LOS Discount modal fields to prevent undefined errors
      addLORModal: false,
      editLORModal: false,
      from_date: null,
      to_date: null,
      stays_from: "",
      stays_upto: "",
      restriction_type: "",
      lor_slug: undefined,
      errors: {},
      lor_disabled_dates: [],
      listing_from_date: null,
      listing_to_date: null,
      maxCheckoutDate: null,
      lorTotalRec: 0,
      lorRecord: [],
      showAlertModal: false,
      alertModalType: "",
      alertModalTitle: "",
      alertModalMessage: "",
      showSpinner: false,
      isSubmit: false,
      publishListingModal: false,
      publishMessage: "",
      publishData: false,
    };
    this.openAddLORModal = this.openAddLORModal.bind(this);
    this.closeAddLORModal = this.closeAddLORModal.bind(this);
    this.lorChangeHandler = this.lorChangeHandler.bind(this);
    this.dateLOrChangeHandler = this.dateLOrChangeHandler.bind(this);
    this.publishListing = this.publishListing.bind(this);
  }

  componentDidMount() {
    this.getInfoData();
    this.fetchAvailability();
    this.getLorData();
  }

  async getInfoData() {
    var resData = {};
    let res = await ListingService.getListing(this.props.listing_slug);

    if (global.successStatus.includes(res.status)) {
      resData.listing_from_date = res.data.from_date
        ? Moment(res.data.from_date, "MM/DD/YYYY").toDate("MM/DD/YYYY")
        : null;
      resData.listing_to_date = res.data.to_date
        ? Moment(res.data.to_date, "MM/DD/YYYY").toDate("MM/DD/YYYY")
        : null;
    }
    this.setState(resData);
  }

  async getLorData(queryString = "") {
    var lorList = [];
    var lorTotalRecords = 0;
    var checkDate = {};
    var dates = [];
    let res = await ListingService.getListingLOR(
      "listing_slug=" +
        this.props.listing_slug +
        (queryString ? "&" + queryString : "")
    );

    if (global.successStatus.includes(res.status)) {
      lorList = res.data ? res.data : [];
      checkDate = res.data ? res.data : {};
      lorTotalRecords = lorList.length ? lorList.length : 0;
    }
    if (lorTotalRecords > 0) {
      checkDate.map((item, index) => {
        let startDate = new Date(item.from_date + " 00:00:00");
        let endDate = new Date(item.to_date + " 00:00:00");
        const date = new Date(startDate.getTime());

        while (date <= endDate) {
          dates.push(new Date(date));
          date.setDate(date.getDate() + 1);
        }
      });
      this.setState({ lor_disabled_dates: dates });
    } else {
      this.setState({ lor_disabled_dates: [] });
    }
    this.setState({
      lorTotalRec: lorTotalRecords,
      lorRecord: lorList,
    });
  }

  fetchAvailability = async () => {
    try {
      let res = await ListingAvailabilityRuleService.getListingAvailabilityRule(
        "listing_slug=" + this.props.listing_slug
      );

      if (global.successStatus.includes(res.status)) {
        const checkinDays = {};
        const checkoutDays = {};
        res.data.forEach((item) => {
          // Assuming API returns day_name, checkin_never_on, checkout_never_on
          checkinDays[item.day_name] = !!item.checkin_never_on;
          checkoutDays[item.day_name] = !!item.checkout_never_on;
        });
        this.setState({ checkinDays, checkoutDays, loading: false });
      }
    } catch (error) {
      console.error("Error fetching availability", error);
    }
  };

  handleCheckboxChange = (type, day) => {
    this.setState((prevState) => ({
      [type]: {
        ...prevState[type],
        [day]: !prevState[type][day],
      },
    }));
  };

  handleSave = async () => {
    this.setState({ showSpinner: true, isSubmit: true });
    const { checkinDays, checkoutDays, days } = this.state;

    // Prepare payload according to backend requirements
    const rules = days.map((day) => ({
      day_name: day,
      checkin_never_on: checkinDays[day] ? 1 : 0,
      checkout_never_on: checkoutDays[day] ? 1 : 0,
    }));

    const payload = {
      property_slug: this.props.property_slug,
      listing_slug: this.props.listing_slug,
      rules,
    };
    try {
      let res =
        await ListingAvailabilityRuleService.addOrUpdateListingAvailabilityRule(
          payload
        );
      if (global.successStatus.includes(res.status)) {
        this.openPublishListingModal(res.message);
      } else {
        if (res.data.result.errorDetail !== null) {
          let errors = {};
          res.data.errorCode = "Validation Failed";
          res.data.result.errorDetail.forEach((item) => {
            errors[item.errorField] = item.errorMessage[0];
            res.data.errorMessage = "";
          });
          this.setState({ errors: errors });
        }
        this.setState({
          showAlertModal: true,
          alertModalType: "error",
          alertModalTitle: res.data.errorCode ? res.data.errorCode : "Error!",
          alertModalMessage: res.data.message ? res.data.message : "Error!",
        });
      }
      this.setState({ showSpinner: false, isSubmit: false });
      setTimeout(
        () => this.setState({ showAlertModal: false }),
        global.alert_close_time
      );
    } catch (error) {
      console.error("Save error", error);
    }
  };

  renderCheckboxes = (type) => {
    const { days } = this.state;
    return (
      <ul className="formcheck-section mg-b-0 flex-wrap">
        {days.map((day) => (
          <li key={type + "-" + day} className="list-vertical">
            <div className="ckbox form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id={`${type}-${day}`}
                checked={this.state[type][day] || false}
                onChange={() => this.handleCheckboxChange(type, day)}
              />
              <label
                htmlFor={`${type}-${day}`}
                className="form-label text-center pd-b-5"
              >
                {day}
              </label>
            </div>
          </li>
        ))}
      </ul>
    );
  };

  async openEditLORModal(from, to, priceType, slug) {
    var selectedRestrictionType = [];
    this.setState({ editLORModal: true });
    this.setState({
      lorUpdateFrom: from,
      lorUpdateTo: to,
      lor_slug: slug,
    });
    var resData = {};
    let dateData = {
      listing_slug: this.props.listing_slug,
      fromDate: from,
      toDate: to,
      priceType: priceType,
      lor_slug: slug,
    };
    let res = await ListingService.showListingLOR(dateData);
    if (global.successStatus.includes(res.status)) {
      resData.unavailable_slug = res.data.slug ? res.data.slug : "";
      resData.restriction_type = res.data.restriction_type
        ? res.data.restriction_type
        : "";

      resData.stays_from = res.data.stays_from ? res.data.stays_from : "";
      resData.stays_upto = res.data.stays_upto ? res.data.stays_upto : "";
      resData.from_date = res.data.from_date
        ? Moment(res.data.from_date).toDate("dd-MM-YYYY")
        : null;
      resData.lor_from_date_b = res.data.from_date ? res.data.from_date : null;
      resData.to_date = res.data.to_date
        ? Moment(res.data.to_date).toDate("dd-MM-YYYY")
        : null;
      resData.lor_to_date_b = res.data.to_date ? res.data.to_date : null;

      selectedRestrictionType = res.data.restriction_type
        ? [
            {
              value: res.data.restriction_type,
              label:
                res.data.restriction_type === 2
                  ? "Arrival based"
                  : res.data.restriction_type === 1
                  ? "Stay through"
                  : "",
            },
          ]
        : "";
    }
    this.setState({ selectedRestrictionType: selectedRestrictionType });
    this.setState(resData);
    setTimeout(() => {
      this.getListingLORBDates(this.props.listing_slug, from, to, 6);
    }, 100);
  }

  async getListingLORBDates(listingSlug, from, to, type) {
    var totalRecords = 0;
    var checkDate = {};
    var dates = [];
    let res = await ListingService.getListingLOSDiscountBlockedDate(
      listingSlug,
      from,
      to,
      type
    );

    if (global.successStatus.includes(res.status)) {
      checkDate = res.data ? res.data : {};
      totalRecords = checkDate.length ? checkDate.length : 0;
    }
    if (totalRecords > 0) {
      checkDate.map((item, index) => {
        let staretDate = new Date(item.from_date + " 00:00:00");
        let endDate = new Date(item.to_date + " 00:00:00");
        const date = new Date(staretDate.getTime());

        while (date <= endDate) {
          dates.push(new Date(date));
          date.setDate(date.getDate() + 1);
        }
      });
      this.setState({ lor_disabled_dates: dates });
    } else {
      this.setState({ lor_disabled_dates: [] });
    }
  }

  openAddLORModal() {
    this.setState({ addLORModal: true });
    this.setState({
      from_date: "",
      to_date: "",
      stays_from: "",
      stays_upto: "",
      restriction_type: "",
      lor_slug: undefined,
      errors: {},
    });
  }

  closeAddLORModal() {
    this.setState({ addLORModal: false });
    this.setState({
      from_date: "",
      to_date: "",
      stays_from: "",
      restriction_type: "",
      stays_upto: "",
      lor_slug: undefined,
      errors: {},
    });

    this.validator.hideMessages();
    this.validator = new SimpleReactValidator({ autoForceUpdate: this });
  }

  closeEditLORModal() {
    this.setState({ editLORModal: false });
    this.setState({
      from_date: "",
      to_date: "",
      stays_from: "",
      restriction_type: "",
      stays_upto: "",
      lor_slug: "",
      errors: {},
    });
    this.getLorData();
    this.validator.hideMessages();
    this.validator = new SimpleReactValidator({ autoForceUpdate: this });
  }

  closeDeleteLORModal() {
    this.setState({ deleteLORModal: false });
    this.setState({ fromDate: "", toDate: "", priceType: "" });
  }

  openDeleteLORModal(from, to, priceType) {
    this.setState({ deleteLORModal: true });
    this.setState({ fromDate: from, toDate: to, priceType: priceType });
  }

  async deleteLORDate(from, to, priceType) {
    this.setState({ showSpinner: true });
    let dateData = {
      listing_slug: this.props.listing_slug,
      fromDate: from,
      toDate: to,
      priceType: priceType,
    };
    let res = await ListingService.deleteListingSpecialPrice(dateData);
    if (global.successStatus.includes(res.status)) {
      this.closeDeleteLORModal();

      this.setState({ disabled_dates: [], los_disabled_dates: [] });
      this.getLorData();
      this.openPublishListingModal();
    } else {
      this.closeDeleteLORModal();
      this.setState({
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: res.data.errorCode ? res.data.errorCode : "Error!",
        alertModalMessage: res.data.errorMessage
          ? res.data.errorMessage
          : res.data.message,
      });
    }
    this.setState({ showSpinner: false });
    this.closeDeleteLORModal();
  }

  getResponsivePlacement = (ref) => {
    if (!ref.current) return "bottom-start";

    const rect = ref.current.getBoundingClientRect();
    const spaceBelow = window.innerHeight - rect.bottom;
    const CALENDAR_HEIGHT_ESTIMATE = 330;
    const CALENDAR_WIDTH_ESTIMATE = 300;

    if (spaceBelow >= CALENDAR_HEIGHT_ESTIMATE || window.innerWidth <= 767) {
      return "bottom-start";
    }

    const spaceRight = window.innerWidth - rect.right;
    const spaceLeft = rect.left;

    if (spaceRight >= CALENDAR_WIDTH_ESTIMATE) return "right-start";
    if (spaceLeft >= CALENDAR_WIDTH_ESTIMATE) return "left-start";
    return spaceRight >= spaceLeft ? "right-start" : "left-start";
  };

  checkFromDatePlacement = () => {
    this.setState({
      fromDatePlacement: this.getResponsivePlacement(this.fromDateInputGroupRef),
    });
  };

  checkToDatePlacement = () => {
    this.setState({
      toDatePlacement: this.getResponsivePlacement(this.toDateInputGroupRef),
    });
  };

  checkEditFromDatePlacement = () => {
    this.setState({
      editFromDatePlacement: this.getResponsivePlacement(this.editFromDateInputGroupRef),
    });
  };

  checkEditToDatePlacement = () => {
    this.setState({
      editToDatePlacement: this.getResponsivePlacement(this.editToDateInputGroupRef),
    });
  };

  dateLOrChangeHandler = (event) => {
    let input = this.state.input || {};
    let value = event.target.value;
    setTimeout(() => {
      if (event.target.name === "from_date") {
        let checkin_date_val = this.state.input.from_date;
        let checkInDate = Moment(checkin_date_val).format("YYYY-MM-DD");
        if (this.state.lor_slug !== undefined) {
          this.getLORUpdateMaxDate(
            this.state.lor_slug,
            this.props.listing_slug,
            checkInDate,
            6
          );
        } else {
          this.getLORMaxDate(this.props.listing_slug, checkInDate, 6);
        }
        this.setState({ to_date: "" });
      }
    }, 200);
    input[event.target.name] = value;
    this.setState({ [event.target.name]: value, input: input });

    // Custom validation for stays_from and stays_upto based on date range
    let fromDate =
      event.target.name === "from_date" ? value : this.state.from_date;
    let toDate = event.target.name === "to_date" ? value : this.state.to_date;
    let stays_from =
      event.target.name === "stays_from" ? value : this.state.stays_from;
    let stays_upto =
      event.target.name === "stays_upto" ? value : this.state.stays_upto;
    let errors = { ...this.state.errors };

    // Check for duplicate/overlapping date range (robust for all date formats, always use date_range error key)
    // Overlap means ANY intersection, including full containment or partial overlap:
    // Example: existing 5-10, new 1-12 => overlap (should block)
    if (
      fromDate &&
      toDate &&
      Moment(fromDate).isValid() &&
      Moment(toDate).isValid()
    ) {
      const newFrom = Moment(fromDate).startOf("day");
      const newTo = Moment(toDate).endOf("day");
      const isEdit = !!this.state.lor_slug;
      const lorRecord = this.state.lorRecord || [];
      const overlap = lorRecord.some((item) => {
        if (isEdit && item.slug === this.state.lor_slug) return false;
        let itemFrom = Moment.isMoment(item.from_date)
          ? item.from_date.clone().startOf("day")
          : Moment(item.from_date, [
              "YYYY-MM-DD",
              "YYYY/MM/DD",
              "MM/DD/YYYY",
              Moment.ISO_8601,
            ]).startOf("day");
        let itemTo = Moment.isMoment(item.to_date)
          ? item.to_date.clone().endOf("day")
          : Moment(item.to_date, [
              "YYYY-MM-DD",
              "YYYY/MM/DD",
              "MM/DD/YYYY",
              Moment.ISO_8601,
            ]).endOf("day");
        // Block if:
        // 1. New range fully contains existing (newFrom <= itemFrom && newTo >= itemTo)
        // 2. Existing fully contains new (itemFrom <= newFrom && itemTo >= newTo)
        // 3. Partial overlap left (newFrom < itemFrom && newTo >= itemFrom)
        // 4. Partial overlap right (newFrom <= itemTo && newTo > itemTo)
        return (
          (newFrom.isSameOrBefore(itemFrom) && newTo.isSameOrAfter(itemTo)) ||
          (itemFrom.isSameOrBefore(newFrom) && itemTo.isSameOrAfter(newTo)) ||
          (newFrom.isBefore(itemFrom) && newTo.isSameOrAfter(itemFrom)) ||
          (newFrom.isSameOrBefore(itemTo) && newTo.isAfter(itemTo))
        );
      });
      if (overlap) {
        errors.date_range =
          "This date range overlaps with an existing restriction.";
      } else {
        if (
          errors.date_range ===
          "This date range overlaps with an existing restriction."
        )
          delete errors.date_range;
      }
      // Remove any old stays_upto overlap error for clarity
      if (
        errors.stays_upto ===
        "This date range overlaps with an existing restriction."
      )
        delete errors.stays_upto;
    }

    if (fromDate && toDate) {
      let start = Moment(fromDate);
      let end = Moment(toDate);
      let diffDays = end.diff(start, "days") + 1;
      if (diffDays < 1) {
        errors.stays_upto = "To date must be after From date.";
      } else {
        delete errors.stays_upto;
        if (stays_from && Number(stays_from) > diffDays) {
          errors.stays_from = `Minimum stay cannot exceed ${diffDays} days for the selected date range.`;
        } else if (stays_from && Number(stays_from) < 1) {
          errors.stays_from = "Minimum stay must be at least 1 day.";
        } else {
          delete errors.stays_from;
        }
        if (stays_upto && Number(stays_upto) > diffDays) {
          errors.stays_upto = `Maximum stay cannot exceed ${diffDays} days for the selected date range.`;
        } else if (stays_upto && Number(stays_upto) < 1) {
          errors.stays_upto = "Maximum stay must be at least 1 day.";
        } else {
          delete errors.stays_upto;
        }
        if (
          stays_from &&
          stays_upto &&
          Number(stays_from) > Number(stays_upto)
        ) {
          errors.stays_from =
            "Minimum stay cannot be greater than maximum stay.";
        }
      }
    } else {
      // If only stays_from or stays_upto is entered, still check for minimum 1
      if (stays_from && Number(stays_from) < 1) {
        errors.stays_from = "Minimum stay must be at least 1 day.";
      } else {
        delete errors.stays_from;
      }
      if (stays_upto && Number(stays_upto) < 1) {
        errors.stays_upto = "Maximum stay must be at least 1 day.";
      } else {
        delete errors.stays_upto;
      }
    }
    this.setState({ errors });

    // Validate
    this.validator.showMessageFor(event.target.name);

    this.setState({ confirm_back: 1 });
  };

  async getLORMaxDate(listingSlug, date, priceType) {
    var checkDateMax = [];
    let res = await ListingService.getSeasonalPriceNextCheckInDate(
      listingSlug,
      date,
      priceType
    );
    if (global.successStatus.includes(res.status)) {
      checkDateMax.set_max_date =
        res && res.data && res.data.set_max_date ? res.data.set_max_date : "";

      var maxCheckOutDate = checkDateMax.set_max_date
        ? Moment(checkDateMax.set_max_date).toDate("dd/MM/YY")
        : this.state.listingTodate
        ? this.state.listingTodate
        : "";
    }
    this.setState({ maxCheckoutDate: maxCheckOutDate });
  }

  async getLORUpdateMaxDate(slug, listing_slug, date, priceType) {
    var checkDateMax = [];
    let res = await ListingService.getSeasonalPricepdateNextCheckInDate(
      slug,
      listing_slug,
      date,
      priceType
    );
    if (global.successStatus.includes(res.status)) {
      checkDateMax.set_max_date =
        res && res.data && res.data.set_max_date ? res.data.set_max_date : "";

      var maxCheckOutDate = checkDateMax.set_max_date
        ? Moment(checkDateMax.set_max_date).toDate("dd/MM/YY")
        : "";
    }
    this.setState({ maxCheckoutDate: maxCheckOutDate });
  }

  lorChangeHandler = (event) => {
    // Ensure input is always an object
    let input = this.state.input || {};
    const value = event.target.value;

    input[event.target.name] = value;
    this.setState({ [event.target.name]: value, input: input });

    // Custom validation for stays_from and stays_upto based on date range
    let fromDate = this.state.from_date;
    let toDate = this.state.to_date;
    let stays_from =
      event.target.name === "stays_from" ? value : this.state.stays_from;
    let stays_upto =
      event.target.name === "stays_upto" ? value : this.state.stays_upto;
    let errors = { ...this.state.errors };

    // Show error if stays_from is empty or null
    if (
      event.target.name === "stays_from" &&
      (value === "" || value === null)
    ) {
      errors.stays_from = "Minimum stay (nights) is required.";
    }

    // Check for duplicate/overlapping date range (robust for all date formats, always use date_range error key)
    if (
      fromDate &&
      toDate &&
      Moment(fromDate).isValid() &&
      Moment(toDate).isValid()
    ) {
      const newFrom = Moment(fromDate).startOf("day");
      const newTo = Moment(toDate).endOf("day");
      const isEdit = !!this.state.lor_slug;
      const lorRecord = this.state.lorRecord || [];
      const overlap = lorRecord.some((item) => {
        if (isEdit && item.slug === this.state.lor_slug) return false;
        let itemFrom = Moment.isMoment(item.from_date)
          ? item.from_date.clone().startOf("day")
          : Moment(item.from_date, [
              "YYYY-MM-DD",
              "YYYY/MM/DD",
              "MM/DD/YYYY",
              Moment.ISO_8601,
            ]).startOf("day");
        let itemTo = Moment.isMoment(item.to_date)
          ? item.to_date.clone().endOf("day")
          : Moment(item.to_date, [
              "YYYY-MM-DD",
              "YYYY/MM/DD",
              "MM/DD/YYYY",
              Moment.ISO_8601,
            ]).endOf("day");
        return (
          (newFrom.isSameOrBefore(itemFrom) && newTo.isSameOrAfter(itemTo)) ||
          (itemFrom.isSameOrBefore(newFrom) && itemTo.isSameOrAfter(newTo)) ||
          (newFrom.isBefore(itemFrom) && newTo.isSameOrAfter(itemFrom)) ||
          (newFrom.isSameOrBefore(itemTo) && newTo.isAfter(itemTo))
        );
      });
      if (overlap) {
        errors.date_range =
          "This date range overlaps with an existing restriction.";
      } else {
        if (
          errors.date_range ===
          "This date range overlaps with an existing restriction."
        )
          delete errors.date_range;
      }
      if (
        errors.stays_upto ===
        "This date range overlaps with an existing restriction."
      )
        delete errors.stays_upto;
    }

    if (fromDate && toDate) {
      let start = Moment(fromDate);
      let end = Moment(toDate);
      let diffDays = end.diff(start, "days");
      if (diffDays < 1) {
        errors.stays_upto = "To date must be after From date.";
      } else {
        delete errors.stays_upto;
        if (stays_from && Number(stays_from) > diffDays) {
          errors.stays_from = `Minimum stay cannot exceed ${diffDays} days for the selected date range.`;
        } else if (stays_from && Number(stays_from) < 1) {
          errors.stays_from = "Minimum stay must be at least 1 day.";
        } else if (!stays_from || stays_from === "") {
          errors.stays_from = "Minimum stay (nights) is required.";
        } else {
          delete errors.stays_from;
        }
        if (stays_upto && Number(stays_upto) > diffDays) {
          errors.stays_upto = `Maximum stay cannot exceed ${diffDays} days for the selected date range.`;
        } else if (stays_upto && Number(stays_upto) < 1) {
          errors.stays_upto = "Maximum stay must be at least 1 day.";
        } else {
          delete errors.stays_upto;
        }
        if (
          stays_from &&
          stays_upto &&
          Number(stays_from) > Number(stays_upto)
        ) {
          errors.stays_from =
            "Minimum stay cannot be greater than maximum stay.";
        }
      }
    } else {
      if (stays_from && Number(stays_from) < 1) {
        errors.stays_from = "Minimum stay must be at least 1 day.";
      } else if (!stays_from || stays_from === "") {
        errors.stays_from = "Minimum stay (nights) is required.";
      } else {
        delete errors.stays_from;
      }
      if (stays_upto && Number(stays_upto) < 1) {
        errors.stays_upto = "Maximum stay must be at least 1 day.";
      } else {
        delete errors.stays_upto;
      }
    }
    this.setState({ errors });

    // Validate
    this.validator.showMessageFor(event.target.name);

    this.setState({ confirm_back: 1 });
  };

  lorTypeList(value) {
    let restriction_type = [];
    if (value != null && value.length > 0) {
      value.forEach((item, i) => {
        restriction_type.push(item.value);
      });
    }
    const restriction_type_value = value !== null ? value.value : [];
    this.setState({
      selectedRestrictionType: value,
      restriction_type: restriction_type_value,
    });
  }

  saveLOR = async (e) => {
    e.preventDefault();
    if (
      !this.validator.errorMessages.from_date &&
      !this.validator.errorMessages.to_date &&
      !this.validator.errorMessages.stays_from &&
      this.state.stays_from.toString().trim() !== "" &&
      !this.state.errors.date_range &&
      (!this.state.errors || Object.keys(this.state.errors).length === 0)
    ) {
      this.setState({ showSpinner: true, isSubmit: true });
      let inputData = {
        listing_slug: this.props.listing_slug ? this.props.listing_slug : "",
        // restriction_type: this.state.restriction_type
        //   ? this.state.restriction_type
        //   : "",
        restriction_type: 2,
        from_date: this.state.from_date
          ? Moment(this.state.from_date, "YYYY-MM-DD").format("YYYY-MM-DD")
          : null,
        to_date: this.state.to_date
          ? Moment(this.state.to_date, "YYYY-MM-DD").format("YYYY-MM-DD")
          : null,
        price_type: 6,
        stays_from: this.state.stays_from ? this.state.stays_from : "",
        stays_upto: this.state.stays_upto ? this.state.stays_upto : "",
      };

      let res = await ListingService.createListingSpecialPrice(inputData);

      if (global.successStatus.includes(res.status)) {
        var last_insert_slug = res.data.last_insert_slug;
        this.setState({ tabWizard: 1, listing_slug: last_insert_slug });
        this.setState({
          from_date: "",
          to_date: "",
          restriction_type: "",
          stays_from: "",
          stays_upto: "",
        });
        this.validator.hideMessages();
        this.closeAddLORModal();
        this.getLorData();
        this.openPublishListingModal(res.message);
      } else {
        if (res.data.result.errorDetail !== null) {
          let errors = {};
          res.data.errorCode = "Validation Failed";
          res.data.result.errorDetail.forEach((item) => {
            errors[item.errorField] = item.errorMessage[0];
            res.data.errorMessage = "";
          });
          this.setState({ errors: errors });
        }
      }

      this.setState({ showSpinner: false, isSubmit: false });
    } else {
      let errors = { ...this.state.errors };
      if (
        !this.state.stays_from ||
        this.state.stays_from.toString().trim() === ""
      ) {
        errors.stays_from = "The minimum stay (nights) is required.";
      }
      this.setState({ errors });
      this.validator.showMessages();
    }
  };

  updateLOSDiscount = async (e) => {
    e.preventDefault();
    if (
      !this.validator.errorMessages.from_date &&
      !this.validator.errorMessages.to_date &&
      !this.validator.errorMessages.stays_from &&
      this.state.stays_from &&
      this.state.stays_from.toString().trim() !== "" &&
      !this.state.errors.date_range &&
      (!this.state.errors || Object.keys(this.state.errors).length === 0)
    ) {
      this.setState({ showSpinner: true, isSubmit: true });

      let inputUpdateData = {
        listing_slug: this.props.listing_slug ? this.props.listing_slug : "",
        // restriction_type: this.state.restriction_type
        //   ? this.state.restriction_type
        //   : "",
        restriction_type: 2,
        from_date: this.state.from_date
          ? Moment(this.state.from_date, "YYYY-MM-DD").format("YYYY-MM-DD")
          : null,
        to_date: this.state.to_date
          ? Moment(this.state.to_date, "YYYY-MM-DD").format("YYYY-MM-DD")
          : null,
        price_type: 6,
        stays_from: this.state.stays_from ? this.state.stays_from : "",
        stays_upto: this.state.stays_upto ? this.state.stays_upto : "",
        updateFrom: this.state.lorUpdateFrom
          ? Moment(this.state.lorUpdateFrom, "YYYY-MM-DD").format("YYYY-MM-DD")
          : null,
        updateTo: this.state.lorUpdateTo
          ? Moment(this.state.lorUpdateTo, "YYYY-MM-DD").format("YYYY-MM-DD")
          : null,
      };
      if (this.state.lorUpdateFrom && this.state.lorUpdateTo) {
        let res = await ListingService.updateListingSpecialPrice(
          inputUpdateData
        );
        if (global.successStatus.includes(res.status)) {
          this.setState({
            restriction_type: "",
            special_price: "",
            from_date: "",
            to_date: "",
            stays_from: "",
            stays_upto: "",
          });
          this.validator.hideMessages();
          this.closeEditLORModal();
          this.getLorData();
          this.openPublishListingModal(res.message);
        } else {
          if (res.data.result.errorDetail !== null) {
            let errors = {};
            res.data.errorCode = "Validation Failed";
            res.data.result.errorDetail.forEach((item) => {
              errors[item.errorField] = item.errorMessage[0];
              res.data.errorMessage = "";
            });
            this.setState({ errors: errors });
          }
        }
      }
      this.setState({ showSpinner: false, isSubmit: false });
    } else {
      let errors = { ...this.state.errors };
      if (
        !this.state.stays_from ||
        this.state.stays_from.toString().trim() === ""
      ) {
        errors.stays_from = "The minimum stay (nights) is required.";
      }
      this.setState({ errors });
      this.validator.showMessages();
    }
  };

  getTitle() {
    return "Availability Rule";
  }

  openPublishListingModal(message) {
    this.setState({ publishListingModal: true, publishMessage: message });
  }

  closePublishListingModal() {
    this.setState({ publishListingModal: false, publishMessage: "" });
  }

  async publishListing() {
    this.setState({ publishData: true });
    let inputData = {
      data: {
        listing_slug: this.props.listing_slug ? this.props.listing_slug : "",
        property_slug: this.props.property_slug ? this.props.property_slug : "",
        unit_slug: this.props.unit_slug ? this.props.unit_slug : "",
        floor_plan_slug: this.props.floor_plan_slug
          ? this.props.floor_plan_slug
          : "",
      },
    };
    let res = await ListingService.publishListing(inputData);
    if (global.successStatus.includes(res.status)) {
      this.setState({
        showAlertModal: true,
        alertModalType: "success",
        alertModalTitle: "Success",
        alertModalMessage: res.message ? res.message : "Success",
      });
      setTimeout(
        () => this.setState({ showAlertModal: false }),
        global.alert_close_time
      );
    } else {
      this.setState({
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: res.data.errorCode ? res.data.errorCode : "Error!",
        alertModalMessage: res.data.message ? res.data.message : "Error!",
      });
      setTimeout(
        () => this.setState({ showAlertModal: false }),
        global.alert_close_time
      );
    }
    this.closePublishListingModal();
    this.setState({ publishData: false });
  }

  render() {
    // const customStyles = {
    //   option: (provided, state) => ({
    //     ...provided,
    //     // color: state.isSelected ? 'black' : ((state.isSelected && state.isFocused) ? "white" : ( state.isFocused && 'white')),
    //     color:
    //       state.isSelected && state.isFocused
    //         ? "white"
    //         : state.isSelected
    //         ? "black"
    //         : state.isFocused && "white",
    //     backgroundColor:
    //       state.isSelected && state.isFocused
    //         ? "black"
    //         : state.isFocused && "black",
    //   }),
    // };
    return (
      <>
        <div className="dashboardRightcard dashbaord-pageHeadertitle- background-none pt-0 pd-l-30 pd-r-30 swipersectionBtns">
          <div className="d-flex flex-wrap justify-content-end bothBtn align-items-center swiperBtns">
            <div className="d-flex">
              {global.userPermissions.checkPermission("single-unit-update") ? (
                <button className="btn-success  mr-3" onClick={this.handleSave}>
                  {this.state.isSubmit ? global.loader : "Save"}
                </button>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="col-md-12 pd-lg-l-30 pd-lg-r-30 pd-xs-l-15 pd-xs-r-0  mg-t-15">
            <Alerts
              show={this.state.showAlertModal}
              type={this.state.alertModalType}
              title={this.state.alertModalTitle}
              message={this.state.alertModalMessage}
            />
          </div>

          <div className="m-0 listing_fee_price">
            <div className="col-lg-12 pd-l-30 pd-r-30 pd-xs-l-15 pd-lg-l-30 pd-xs-r-0 pd-lg-r-30">
              <h3 className="mg-l-0 background-head"> Changeover </h3>
            </div>
            <div className="row col-md-12 mg-lg-t-0 mg-xs-t-10 mg-md-t-0 pd-l-0 pd-r-30 pd-xs-l-15 pd-lg-l-0 pd-xs-r-0 pd-lg-r-30 border-bottom-0">
              <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mg-t-5 mg-md-t-0 mg-b-15 pd-xs-l-0 pd-lg-l-30 pd-xs-r-0 pd-lg-r-30">
                <label className="form-label text-left pd-b-5 chbx-label">
                  Check-in never on
                </label>
                {this.renderCheckboxes("checkinDays")}
              </div>

              <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mg-t-5 mg-md-t-0 mg-b-15 pd-xs-l-0 pd-lg-l-30 pd-xs-r-0 pd-lg-r-30">
                <label className="form-label text-left pd-b-5 chbx-label">
                  Check-out never on
                </label>
                {this.renderCheckboxes("checkoutDays")}
              </div>
            </div>
            <div className="col-lg-12 pd-l-30 pd-r-30 pd-xs-l-15 pd-lg-l-30 pd-xs-r-0 pd-lg-r-30">
              <div className="background-head d-flex justify-content-between align-items-center flex-wrap mg-b-0">
                <h3 className="mb-0">Length of stay restrictions</h3>
                {global.userPermissions.checkPermission(
                  "single-unit-update"
                ) ? (
                  <React.Fragment>
                    <div className="d-flex">
                      <button
                        className="btn-success-outline-small"
                        onClick={this.openAddLORModal}
                      >
                        Add
                      </button>
                    </div>
                  </React.Fragment>
                ) : (
                  ""
                )}
              </div>
            </div>

            <div className="row col-md-12 mg-lg-t-0 mg-xs-t-10 mg-md-t-0 pd-l-30 pd-r-30 pd-xs-l-15 pd-lg-l-30 pd-xs-r-0 pd-lg-r-30 border-bottom-0">
              <div className="table-responsive">
                <Table hover className="table_heading_top">
                  <thead>
                    <tr>
                      <th className="w-40">From</th>
                      <th className="w-40">To</th>
                      <th className="w-40">Minimum stay (nights)</th>
                      <th className="w-40">Maximum stay (nights) </th>
                      {/* <th className="w-40">Restriction type</th> */}

                      <th className="text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.lorTotalRec > 0 ? (
                      this.state.lorRecord.map((item, i) => {
                        return (
                          <tr key={i}>
                            <td
                              onClick={() =>
                                this.openEditLORModal(
                                  Moment(item.from_date, "YYYY/MM/DD").format(
                                    "YYYY-MM-DD"
                                  ),
                                  Moment(item.to_date, "YYYY/MM/DD").format(
                                    "YYYY-MM-DD"
                                  ),
                                  6,
                                  item.slug
                                )
                              }
                              className="hand-cursor"
                            >
                              {Moment(item.from_date, "YYYY/MM/DD").format(
                                global.dateFormat
                              )}
                            </td>
                            <td
                              onClick={() =>
                                this.openEditLORModal(
                                  Moment(item.from_date, "YYYY/MM/DD").format(
                                    "YYYY-MM-DD"
                                  ),
                                  Moment(item.to_date, "YYYY/MM/DD").format(
                                    "YYYY-MM-DD"
                                  ),
                                  6,
                                  item.slug
                                )
                              }
                              className="hand-cursor"
                            >
                              {Moment(item.to_date, "YYYY/MM/DD").format(
                                global.dateFormat
                              )}
                            </td>
                            <td
                              onClick={() =>
                                this.openEditLORModal(
                                  Moment(item.from_date, "YYYY/MM/DD").format(
                                    "YYYY-MM-DD"
                                  ),
                                  Moment(item.to_date, "YYYY/MM/DD").format(
                                    "YYYY-MM-DD"
                                  ),
                                  6,
                                  item.slug
                                )
                              }
                              className="hand-cursor"
                            >
                              {item.stays_from ? item.stays_from : ""}
                            </td>
                            <td
                              onClick={() =>
                                this.openEditLORModal(
                                  Moment(item.from_date, "YYYY/MM/DD").format(
                                    "YYYY-MM-DD"
                                  ),
                                  Moment(item.to_date, "YYYY/MM/DD").format(
                                    "YYYY-MM-DD"
                                  ),
                                  6
                                )
                              }
                              className="hand-cursor"
                            >
                              {item.stays_upto ? item.stays_upto : ""}
                            </td>
                            {/* <td
                              onClick={() =>
                                this.openEditLORModal(
                                  Moment(item.from_date, "YYYY/MM/DD").format(
                                    "YYYY-MM-DD"
                                  ),
                                  Moment(item.to_date, "YYYY/MM/DD").format(
                                    "YYYY-MM-DD"
                                  ),
                                  6
                                )
                              }
                              className="hand-cursor"
                            >
                              {item.restriction_type &&
                              item.restriction_type === 1
                                ? "Stay through"
                                : item.restriction_type &&
                                  item.restriction_type === 2
                                ? "Arrival based"
                                : ""}
                            </td> */}
                            <td>
                              <div className="btn-icon-list d-block text-center">
                                <img
                                  src={deleteicon}
                                  alt="Delete"
                                  onClick={() =>
                                    this.openDeleteLORModal(
                                      Moment(
                                        item.from_date,
                                        "YYYY/MM/DD"
                                      ).format("YYYY-MM-DD"),
                                      Moment(item.to_date, "YYYY/MM/DD").format(
                                        "YYYY-MM-DD"
                                      ),
                                      6
                                    )
                                  }
                                  className="hand-cursor"
                                />
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="9" align="center">
                          There are no length of stay restrictions added in the
                          system. You may add them by clicking Add button.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        </div>
        <Modal show={this.state.publishListingModal} centered>
          <Modal.Body className="width_402 p-4 border_radius_14">
            <div className="text-center">
              <span
                className="welcomeClose"
                onClick={() => this.closePublishListingModal()}
              >
                {global.closee}
              </span>
              <p>
                {this.state.publishMessage
                  ? this.state.publishMessage
                  : "Listing is successfully updated! Your changes are not published to OTA yet, do you want to publish now ? You can still publish from Sync tab later."}
              </p>
              <div className="d-flex justify-content-center mt-3 row">
                <button
                  type="button"
                  className="m-0 btn btn-outline-light btn-block button-width"
                  onClick={() => this.closePublishListingModal()}
                >
                  Sync Later
                </button>
                <button
                  type="button"
                  className="m-0 btn btn btn-danger btn-block button-width"
                  onClick={this.publishListing}
                  disabled={this.state.isSubmit ? true : false}
                >
                  {this.state.isSubmit ? global.loader : "Sync Now"}
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
        <Modal
          show={this.state.addLORModal}
          onHide={() => {
            if (window.confirm("Do you want to exit without saving?"))
              this.closeAddLORModal();
          }}
          centered
        >
          <Modal.Body className="width_402 p-4 border_radius_14">
            <span
              className="welcomeClose"
              onClick={() => this.closeAddLORModal()}
            >
              {global.closee}
            </span>
            <h3 className="text-center">Add Length of stay restrictions</h3>
            <InputGroup className="mt-3" ref={this.fromDateInputGroupRef}>
              <label>From</label>
              <DatePicker
                className="form-control max_width_100"
                disabledKeyboardNavigation
                strictParsing
                scrollableYearDropdown
                autoComplete="off"
                showMonthDropdown
                showYearDropdown
                yearDropdownItemNumber={global.yearDropdownItemNumber}
                excludeDates={this.state.lor_disabled_dates}
                //maxDate={this.state.to_date}
                name="from_date"
                dateFormat="MM/dd/yy"
                minDate={
                  this.state.listing_from_date
                    ? this.state.listing_from_date
                    : new Date()
                }
                maxDate={
                  this.state.listing_to_date ? this.state.listing_to_date : ""
                }
                selected={this.state.from_date}
                onChange={(data) =>
                  this.dateLOrChangeHandler({
                    target: {
                      type: "date",
                      name: "from_date",
                      value: data,
                    },
                  })
                }
                popperPlacement={this.state.fromDatePlacement}
                onCalendarOpen={this.checkFromDatePlacement}
                popperModifiers={{
                  preventOverflow: {
                    enabled: true,
                    escapeWithReference: false,
                  },
                }}
              />
              {this.state.errors.from_date || this.state.errors.date_range ? (
                <div className="text-danger">
                  {this.state.errors.from_date || this.state.errors.date_range}
                </div>
              ) : (
                this.validator.message(
                  "from_date",
                  this.state.from_date,
                  "required",
                  { className: "text-danger" }
                )
              )}
            </InputGroup>

            <InputGroup className="mt-3" ref={this.toDateInputGroupRef}>
              <label>To</label>
              <DatePicker
                className="form-control max_width_100"
                disabledKeyboardNavigation
                strictParsing
                scrollableYearDropdown
                autoComplete="off"
                showMonthDropdown
                showYearDropdown
                yearDropdownItemNumber={global.yearDropdownItemNumber}
                excludeDates={this.state.lor_disabled_dates}
                minDate={
                  this.state.from_date ? this.state.from_date : new Date()
                }
                maxDate={
                  this.state.maxCheckoutDate
                    ? this.state.maxCheckoutDate
                    : this.state.listing_to_date
                    ? this.state.listing_to_date
                    : ""
                }
                name="to_date"
                dateFormat="MM/dd/yy"
                selected={this.state.to_date}
                onChange={(data) =>
                  this.dateLOrChangeHandler({
                    target: {
                      type: "date",
                      name: "to_date",
                      value: data,
                    },
                  })
                }
                popperPlacement={this.state.toDatePlacement}
                onCalendarOpen={this.checkToDatePlacement}
                popperModifiers={{
                  preventOverflow: {
                    enabled: true,
                    escapeWithReference: false,
                  },
                }}
              />
              {this.state.errors.to_date || this.state.errors.date_range ? (
                <div className="text-danger">
                  {this.state.errors.to_date || this.state.errors.date_range}
                </div>
              ) : (
                this.validator.message(
                  "to_date",
                  this.state.to_date,
                  "required",
                  { className: "text-danger" }
                )
              )}
            </InputGroup>

            <InputGroup className="mt-3">
              <label>Minimum stay (nights)</label>
              <Form.Control
                type="number"
                min={1}
                max={60}
                onChange={this.lorChangeHandler}
                name="stays_from"
                value={this.state.stays_from ? this.state.stays_from : ""}
                maxLength="2"
                onKeyPress={global.onKeyPressEvent.numberValidation}
              />
              {this.state.errors.stays_from ? (
                <div className="text-danger">
                  {this.state.errors.stays_from}
                </div>
              ) : (
                this.validator.message(
                  "Minimum stay (nights)",
                  this.state.stays_from,
                  "required|numeric|min:1|max:60",
                  { className: "text-danger" }
                )
              )}
            </InputGroup>

            <InputGroup className="mt-3">
              <label>Maximum stay (nights)</label>
              <Form.Control
                type="number"
                min={1}
                max={60}
                onChange={this.lorChangeHandler}
                name="stays_upto"
                value={this.state.stays_upto ? this.state.stays_upto : ""}
                maxLength="2"
                onKeyPress={global.onKeyPressEvent.numberValidation}
              />
              {this.state.errors.stays_upto ? (
                <div className="text-danger">
                  {this.state.errors.stays_upto}
                </div>
              ) : null}
            </InputGroup>

            {/* <InputGroup className="mt-3">
              <label>Restriction type</label>
              <div className="col-md-12 p-0">
                <Select
                  styles={customStyles}
                  isClearable={true}
                  menuPlacement="auto"
                  className="multiselect"
                  options={this.state.restrictionTypeList}
                  getOptionValue={(option) => `${option.label}`}
                  onChange={(value) => this.lorTypeList(value)}
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 2,
                    colors: {
                      ...theme.colors,
                      primary: "#fff",
                      primary75: "#000",
                      primary50: "#000",
                      primary25: "#000",
                    },
                  })}
                />
              </div>
            </InputGroup> */}

            <div className="d-flex justify-content-center mt-3 row">
              <button
                type="button"
                className=" m-0 btn btn-outline-light btn-block"
                onClick={() => this.closeAddLORModal()}
              >
                Cancel
              </button>
              <button
                type="button"
                className="m-0 btn btn btn-success btn-block"
                onClick={this.saveLOR}
                disabled={this.state.isSubmit ? true : false}
              >
                {this.state.isSubmit ? global.loader : "Save"}
              </button>
            </div>
          </Modal.Body>
        </Modal>

        <Modal
          show={this.state.editLORModal}
          onHide={() => {
            if (window.confirm("Do you want to exit without saving?"))
              this.closeEditLORModal();
          }}
          centered
        >
          <Modal.Body className="width_402 p-4 border_radius_14">
            <span
              className="welcomeClose"
              onClick={() => this.closeEditLORModal()}
            >
              {global.closee}
            </span>
            <h3 className="text-center">Update Length of stay restrictions</h3>

            <InputGroup className="mt-3" ref={this.editFromDateInputGroupRef}>
              <label>From</label>
              <DatePicker
                className="form-control max_width_100"
                disabledKeyboardNavigation
                strictParsing
                scrollableYearDropdown
                autoComplete="off"
                showMonthDropdown
                showYearDropdown
                yearDropdownItemNumber={global.yearDropdownItemNumber}
                excludeDates={this.state.lor_disabled_dates}
                //maxDate={this.state.to_date}
                name="from_date"
                dateFormat="MM/dd/yy"
                minDate={
                  this.state.listing_from_date
                    ? this.state.listing_from_date
                    : new Date()
                }
                maxDate={
                  this.state.listing_to_date ? this.state.listing_to_date : ""
                }
                // maxDate={this.state.to_date}
                selected={this.state.from_date}
                onChange={(data) =>
                  this.dateLOrChangeHandler({
                    target: {
                      type: "date",
                      name: "from_date",
                      value: data,
                    },
                  })
                }
                popperPlacement={this.state.editFromDatePlacement}
                onCalendarOpen={this.checkEditFromDatePlacement}
                popperModifiers={{
                  preventOverflow: {
                    enabled: true,
                    escapeWithReference: false,
                  },
                }}
              />
              {this.state.errors.from_date || this.state.errors.date_range ? (
                <div className="text-danger">
                  {this.state.errors.from_date || this.state.errors.date_range}
                </div>
              ) : (
                this.validator.message(
                  "from_date",
                  this.state.from_date,
                  "required",
                  { className: "text-danger" }
                )
              )}
            </InputGroup>

            <InputGroup className="mt-3" ref={this.editToDateInputGroupRef}>
              <label>To</label>
              <DatePicker
                className="form-control max_width_100"
                disabledKeyboardNavigation
                strictParsing
                scrollableYearDropdown
                autoComplete="off"
                showMonthDropdown
                showYearDropdown
                yearDropdownItemNumber={global.yearDropdownItemNumber}
                excludeDates={this.state.lor_disabled_dates}
                minDate={
                  this.state.from_date ? this.state.from_date : new Date()
                }
                maxDate={
                  this.state.maxCheckoutDate
                    ? this.state.maxCheckoutDate
                    : this.state.listing_to_date
                    ? this.state.listing_to_date
                    : ""
                }
                name="to_date"
                dateFormat="MM/dd/yy"
                selected={this.state.to_date}
                onChange={(data) =>
                  this.dateLOrChangeHandler({
                    target: {
                      type: "date",
                      name: "to_date",
                      value: data,
                    },
                  })
                }
                popperPlacement={this.state.editToDatePlacement}
                onCalendarOpen={this.checkEditToDatePlacement}
                popperModifiers={{
                  preventOverflow: {
                    enabled: true,
                    escapeWithReference: false,
                  },
                }}
              />
              {this.state.errors.to_date || this.state.errors.date_range ? (
                <div className="text-danger">
                  {this.state.errors.to_date || this.state.errors.date_range}
                </div>
              ) : (
                this.validator.message(
                  "to_date",
                  this.state.to_date,
                  "required",
                  { className: "text-danger" }
                )
              )}
            </InputGroup>

            <InputGroup className="mt-3">
              <label>Minimum stay (nights)</label>
              <Form.Control
                type="text"
                onChange={this.lorChangeHandler}
                name="stays_from"
                value={this.state.stays_from ? this.state.stays_from : "" || ""}
                min={1}
                max={60}
                maxLength="2"
                onKeyPress={global.onKeyPressEvent.numberValidation}
              />
              {this.state.errors.stays_from ? (
                <div className="text-danger">
                  {this.state.errors.stays_from}
                </div>
              ) : (
                this.validator.message(
                  "Minimum stay (nights)",
                  this.state.stays_from,
                  "required|numeric|min:1",
                  { className: "text-danger" }
                )
              )}
            </InputGroup>

            <InputGroup className="mt-3">
              <label>Maximum stay (nights)</label>
              <Form.Control
                type="text"
                onChange={this.lorChangeHandler}
                name="stays_upto"
                value={this.state.stays_upto ? this.state.stays_upto : "" || ""}
                maxLength="10"
                onKeyPress={global.onKeyPressEvent.numberValidation}
              />
              {this.state.errors.stays_upto ? (
                <div className="text-danger">
                  {this.state.errors.stays_upto}
                </div>
              ) : null}
            </InputGroup>

            {/* <InputGroup className="mt-3">
              <label>Restriction type</label>
              <div className="col-md-12 p-0">
                <Select
                  styles={customStyles}
                  isClearable={true}
                  menuPlacement="auto"
                  className="multiselect"
                  options={this.state.restrictionTypeList}
                  defaultValue={this.state.selectedRestrictionType}
                  value={this.state.selectedRestrictionType}
                  getOptionValue={(option) => `${option.label}`}
                  onChange={(value) => this.lorTypeList(value)}
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 2,
                    colors: {
                      ...theme.colors,
                      primary: "#fff",
                      primary75: "#000",
                      primary50: "#000",
                      primary25: "#000",
                    },
                  })}
                />
              </div>
            </InputGroup> */}

            <div className="d-flex justify-content-center mt-3">
              <button
                type="button"
                className="m-0 btn btn-outline-light btn-block"
                onClick={() => this.closeEditLORModal()}
              >
                Cancel
              </button>
              <button
                type="button"
                className=" m-0 btn btn btn-success btn-block"
                onClick={this.updateLOSDiscount}
                disabled={this.state.isSubmit ? true : false}
              >
                {this.state.isSubmit ? global.loader : "Save"}
              </button>
            </div>
          </Modal.Body>
        </Modal>
        <Modal
          show={this.state.deleteLORModal}
          onHide={() => {
            if (
              window.confirm("Are you sure to exit the pop up without delete?")
            )
              this.closeDeleteLORModal();
          }}
          centered
        >
          <Modal.Body className="width_402 p-4 border_radius_14">
            <span
              className="welcomeClose"
              onClick={() => this.closeDeleteLORModal()}
            >
              {global.closee}
            </span>
            <div className="text-center">
              <img src={deleteicon} alt="modal-delete-icon" />
              <h3>Delete the Option?</h3>
              <p>
                Do you really want to delete this option? This process cannot be
                undone.
              </p>
              <div className="d-flex justify-content-center mt-3 row">
                <button
                  type="button"
                  className=" m-0 btn btn-outline-light btn-block"
                  onClick={() => this.closeDeleteLORModal()}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="m-0 btn btn btn-danger btn-block"
                  onClick={() =>
                    this.deleteLORDate(
                      this.state.fromDate,
                      this.state.toDate,
                      this.state.priceType
                    )
                  }
                  disabled={this.state.isSubmit ? true : false}
                >
                  {this.state.isSubmit ? global.loader : "Delete"}
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

export default ListingAvailabilityRule;
